import { create } from "zustand";

export interface PromptOptions {
  title: string;
  description?: string;
  placeholder?: string;
  defaultValue?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  multiline?: boolean;
  validate?: (v: string) => string | null;
}

export interface ConfirmOptions {
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

type DialogState =
  | { kind: "prompt"; opts: PromptOptions; resolve: (v: string | null) => void }
  | { kind: "confirm"; opts: ConfirmOptions; resolve: (v: boolean) => void }
  | null;

interface DialogStore {
  current: DialogState;
  openPrompt: (opts: PromptOptions) => Promise<string | null>;
  openConfirm: (opts: ConfirmOptions) => Promise<boolean>;
  _resolve: (value: any) => void;
}

export const useDialog = create<DialogStore>((set, get) => ({
  current: null,

  openPrompt: (opts) =>
    new Promise<string | null>((resolve) => {
      set({ current: { kind: "prompt", opts, resolve } });
    }),

  openConfirm: (opts) =>
    new Promise<boolean>((resolve) => {
      set({ current: { kind: "confirm", opts, resolve } });
    }),

  _resolve: (value) => {
    const cur = get().current;
    if (!cur) return;
    cur.resolve(value as never);
    set({ current: null });
  },
}));

// Helpers que podem ser chamados de qualquer lugar sem hooks
export function promptAsync(opts: PromptOptions): Promise<string | null> {
  return useDialog.getState().openPrompt(opts);
}

export function confirmAsync(opts: ConfirmOptions): Promise<boolean> {
  return useDialog.getState().openConfirm(opts);
}
